<template>
  <div no-body class="lku-koran-cust">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row>
    <b-row v-else>
      <b-col lg="9">
        <b-form-group
          style="margin-bottom:-4px !important;"
          horizontal
          label="Filter"
          label-cols="1"
        >
          <b-row>
            <b-col class="pr-1" cols="3">
              <b-form-input
                v-model="tblData.code"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Code"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.name"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Name"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.customer_group"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="customer group"
                :disabled="fltrDisabled"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.SalesCode"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Sales Code"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group style="margin-bottom:-4px !important;" horizontal>
          <b-row>
            <b-button class="btn btn-success mr-1" @click="search()" size="sm">
              <i class="fa fa-search"></i> Search
            </b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblKoranCust"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
      show-empty
    >
      <template
        v-slot:cell(addressBill)="data"
      >{{data.item.Address1}} {{data.item.Address2?data.item.Address2:''}}</template>
      <!-- <template v-slot:empty="scope">
        <h4>{{ scope.emptyText }}</h4>
      </template>
      <template v-slot:emptyfiltered="scope">
        <h4>{{ scope.emptyFilteredText }}</h4>
      </template> -->
    </b-table>
    <b-row>
      <b-col cols="6">
        <div>
          Showing
          {{(tblData.page - 1) * tblData.limit + 1}}
          to
          {{tblData.page * tblData.limit}}
          of
          {{tblData.total}}
          entries
        </div>
      </b-col>
      <b-col cols="6">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import customer from "../../apis/koran_customer";
export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true
        },
        {
          key: "CustCode",
          thStyle: "width:50px",
          label: "Code",
          sortable: true
        },
        {
          key: "addressBill",
          label: "Billing Address"
        },
        {
          key: "City",
          label: "City",
          sortable: true
        },
        {
          key: "PhoneNo",
          label: "Phone/Fax",
          thStyle: "width:150px"
        },
        // {
        //   key: "npwp",
        //   label: "N P W P",
        //   thStyle: "width:150px",
        //   sortable: true
        // },
        {
          key: "collector",
          label: "Collector",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "sales",
          label: "Sales (AE)",
          thStyle: "width:150px",
          sortable: true
        }
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      lkuLoading: false,
      fltrDisabled: false
    };
  },
  props: ["filter", "customer_group", "bill2group"],
  created: function() {
        this.tblData.customer_group = this.customer_group || '';
        this.tblData.bill2group = this.bill2group || '';
  },
    methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // if (this.customer_group) {
      //   this.tblData.customer_group = this.customer_group;
        // this.fltrDisabled = true;
      // }
      const list = await customer.korancustomer(this.tblData);
      return list;
    },

    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.name = "";
      this.tblData.code = "";
      this.tblData.customer_group = "";
      this.tblData.SalesCode = "";
      this.refresh();
    },
    refresh: async function() {
      this.$refs.tblKoranCust.refresh();
    },
    search: async function() {
      this.tblData.page=1;
      this.$refs.tblKoranCust.refresh();
    }

  }
};
</script>
